import * as types from './mutations_type';

export const state = {
  loading: false,
  userInfo: {},
  agentList: [],
  storeList: [],
  agentInfo: '',
  ecuStoreList: [],
};

export const mutations = {
  // eslint-disable-next-line
  [types.SET_LOADING](state, value) {
    state.loading = value;
  },
  // eslint-disable-next-line
  [types.SET_USERINFO](state, value) {
    state.userInfo = value;
  },
  // eslint-disable-next-line
  [types.SET_AGENT_INFO](state, res) {
    state.agentInfo = res;
  },
  // eslint-disable-next-line
  [types.SET_AGENT_LIST](state, res) {
    state.agentList = res;
  },
  // eslint-disable-next-line
  [types.SET_STORE_LIST](state, res) {
    state.storeList = res;
  },
  // eslint-disable-next-line
  [types.SET_ECU_STORE_LIST](state, res) {
    state.ecuStoreList = res;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js